export const siteUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}`
}

export const siteMapUrlBuilder = (siteId: string, featureId: string | null) : string => {
    return `/sites/${siteId}/map${featureId ? `?featureId=${featureId}` : ""}`
}

export const actionEditUrlBuilder = (siteId: string, actionId: string) : string => {
    return `/sites/${siteId}/tasks/${actionId}`
}

export const featureUrlBuilder = (siteId: string, featureId: string) : string => {
    return `/sites/${siteId}/features/${featureId}`
}

export const areaCreateUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/area/create`
}

export const siteActionsUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/tasks`
}

export const siteObservationsUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/observations`
}

export const areaUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/area`
}

export const areaIndexUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}`
}

export const areaCourseFeatureUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}/coursefeature`
}

export const areaCourseObservationsUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}/courseobservations`
}

export const areaHabitatFeatureUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}/habitatfeature`
}

export const areaHabitatObservationsUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}/habitatobservations`
}

export const areaTasksUrlBuilder = (siteId: string, areaId: string) : string => {
    return `/sites/${siteId}/area/${areaId}/tasks`
}

export const observationUrlBuilder = (siteId: string, observationId: string) : string => {
    return `/sites/${siteId}/observations/${observationId}`
}

export const courseUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/course`
}

export const featureTypeCreateUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/featuretypes/create`
}

export const featureTypeEditUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `/sites/${siteId}/featuretypes/${featureTypeId}`
}

export const featureTypeFeatureListUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `/sites/${siteId}/featuretypes/${featureTypeId}/features`
}

export const featureTypeActionListUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `/sites/${siteId}/featuretypes/${featureTypeId}/tasks`
}

export const featureTypeUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `/sites/${siteId}/featuretypes/${featureTypeId}`
}

export const featureTypeObservationListUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `/sites/${siteId}/featuretypes/${featureTypeId}/observations`
}

export const featureTypeCreateActionUrlBuilder = (siteId: string, featureTypeId: string) : string => {
    return `${createActionUrlBuilder(siteId)}?featureTypeId=${featureTypeId}`
}

export const habitatUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/habitat`
}

export const projectUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/project`
}

export const projectCreateUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/project/create`
}

export const projectEditUrlBuilder = (siteId: string, projectId: string) : string => {
    return `/sites/${siteId}/project/${projectId}`
}

export const projectTasksUrlBuilder = (siteId: string, projectId: string) : string => {
    return `/sites/${siteId}/project/${projectId}/tasks`
}

export const projectCreateActionUrlBuilder = (siteId: string, projectId: string) : string => {
    return `${createActionUrlBuilder(siteId)}?projectid=${projectId}`
}

export const featureCreateActionUrlBuilder = (siteId: string, featureId: string) : string => {
    return `${createActionUrlBuilder(siteId)}?featureId=${featureId}`
}

export const siteCreateActionUrlBuilder = (siteId: string) : string => {
    return createActionUrlBuilder(siteId)
}

export const featureObservationsUrlBuilder = (siteId: string, featureId: string) : string => {
    return `/sites/${siteId}/features/${featureId}/observations`
}

export const featureCreateObservationUrlBuilder = (siteId: string, featureId: string) : string => {
    return `${observationCreateActionUrlBuilder(siteId)}?featureId=${featureId}`
}

export const featureTasksUrlBuilder = (siteId: string, featureId: string) : string => {
    return `/sites/${siteId}/features/${featureId}/tasks`
}

const createActionUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/tasks/create`
}

const observationCreateActionUrlBuilder = (siteId: string) : string => {
    return `/sites/${siteId}/observations/create`
}